import _ from "lodash"

var isRegExp = function (re) {
    return re instanceof RegExp
}
var escapeRegExp = function escapeRegExp(string) {
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
        reHasRegExpChar = RegExp(reRegExpChar.source)

    return string && reHasRegExpChar.test(string)
        ? string.replace(reRegExpChar, '\\$&')
        : string
}
var isString = function (value) {
    return typeof value === 'string'
}
var flatten = function (array) {
    var newArray = []

    array.forEach(function (item) {
        if (Array.isArray(item)) {
            newArray = newArray.concat(item)
        } else {
            newArray.push(item)
        }
    })

    return newArray
}

function replaceString(str, match, fn) {
    var curCharStart = 0
    var curCharLen = 0

    if (str === '' || !str || !isString(str)) {
        return str
    }

    var re = match

    if (!isRegExp(re)) {
        re = new RegExp('(' + escapeRegExp(re) + ')', 'gi')
    }

    var result = str.split(re)

    for (var i = 1, length = result?.length; i < length; i += 2) {
        if (result[i] === undefined || result[i - 1] === undefined) {
            continue
        }

        curCharLen = result[i]?.length
        curCharStart += result[i - 1]?.length
        result[i] = fn(result[i], i, curCharStart)
        curCharStart += curCharLen
    }

    return result
}

export function nodeReplace(source, match, fn) {
    if (!Array.isArray(source)) source = [source]
    return flatten(
        source.map(function (x) {
            return isString(x) ? replaceString(x, match, fn) : x
        })
    )
}


export function checkAllowUrl(url) {
    const allowedDomains = ['google.com', 'zoom.us', 'kristo.network'];
    const domain = new URL(url).hostname;

    return allowedDomains.some(allowedDomain => domain.includes(allowedDomain));
}


export const extractTypeAndIdFromUrl = (url) => {
    // Tách đường dẫn từ URL
    const path = new URL(url).pathname; // Sử dụng URL để lấy đường dẫn
    const segments = _.filter(path.split('/')); // Tách và loại bỏ các phần tử rỗng

    // Kiểm tra có đủ 2 phần tử để lấy type và id
    if (segments?.length >= 2) {
        const type = _.nth(segments, -2); // Phần trước cùng
        const id = _.nth(segments, -1);   // Phần sau cùng
        return {type, id};
    }
    return null; // Trả về null nếu không đủ thông tin
};

export function truncateMiddle(text, maxLength = 50) {
    if (text?.length <= maxLength) return text;
    const half = Math.floor(maxLength / 2) - 1;
    return text.slice(0, half) + '...' + text.slice(-half);
}